//tslint:disable: no-any
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { OfferHistory } from '../components';
import { FeedContainer } from './FeedContainer';
import { FiltersContainer } from './FiltersContainer';
import { ShowMoreContainer } from './ShowMoreContainer';
import { getOfferHistory } from '../../../store/offerHistory/actions';
import { selectOfferHistoryData } from '../../../store/offerHistory/selectors';
import { ElementInViewport } from '../../../common/components/elementInViewport';
import { useTrackIntoView } from './analytics/useTrackIntoView';

export const OfferHistoryContainer: React.FC = () => {
  const dispatch = useDispatch();
  const offerHistoryData = useSelector(selectOfferHistoryData);
  const trackIntoView = useTrackIntoView();

  React.useEffect(() => {
    if (!offerHistoryData) {
      dispatch(getOfferHistory(false));
    }
  }, [dispatch]);

  if (!offerHistoryData || !offerHistoryData.offers.length) {
    return null;
  }

  return (
    <ElementInViewport onChange={trackIntoView}>
      <OfferHistory
        title={offerHistoryData.blockTitle}
        filters={<FiltersContainer />}
        feed={<FeedContainer />}
        showMoreBtn={<ShowMoreContainer />}
      />
    </ElementInViewport>
  );
};

OfferHistoryContainer.displayName = 'OfferHistoryContainer';
